<template>
  <div class="flex flex-col space-y-2">
    <div
      class="flex justify-between space-x-2 items-center bg-white border border-gray-200 rounded-md p-2.5 cursor-pointer"
      v-for="file in props.files"
      :key="file.id"
      @click="downloadFile(file.urls.file)"
    >
      <FileFive class="flex shrink-0 w-6 h-6 text-green-600" />

      <span class="grow truncate text-ellipsis text-sm">{{ file.name }}</span>

      <XMarkIcon
        v-if="!disabled"
        @click.stop="emit('delete', file.id)"
        class="h-5 w-5 cursor-pointer text-gray-400 hover:text-gray-500"
        aria-hidden="true"
      />
    </div>
  </div>
</template>

<script setup>
import FileFive from "@/Tailwind/Icon/FileFive.vue";
import { defineProps, defineEmits } from "vue";
import { XMarkIcon } from "@heroicons/vue/24/outline";
import { mobileSatisfiesVersion } from "@/Tailwind/Helpers/version";
import { useWebView } from "@/Tailwind/Mixins/useWebView";

const emit = defineEmits(["delete"]);
const props = defineProps({
  files: Array,
  disabled: Boolean,
});

const { runningInWebView, openURL } = useWebView();
const downloadFile = (url) => {
  if (!runningInWebView()) {
    window.open(url, "_blank");
    return;
  }

  if (mobileSatisfiesVersion("2.2.0")) {
    openURL(url);
    return;
  }

  // Fallback for outdated mobile apps.
  window.open(url, "_blank");
};
</script>
